/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether it is supplied once per trusted platform or once per access rule.
 */
export const WorkloadPlatformVariableTier = {
  Platform: "platform",
  Rule: "rule",
} as const;
/**
 * Whether it is supplied once per trusted platform or once per access rule.
 */
export type WorkloadPlatformVariableTier = ClosedEnum<
  typeof WorkloadPlatformVariableTier
>;

/**
 * Something the operator supplies when connecting a catalog platform.
 */
export type WorkloadPlatformVariable = {
  /**
   * Where the operator finds the value. Empty where there is no help.
   */
  help: string;
  /**
   * Names the variable in templates, as {key}.
   */
  key: string;
  /**
   * The field's label.
   */
  label: string;
  /**
   * A regular expression the whole value must match.
   */
  pattern: string;
  /**
   * Shown when the value does not match. Empty where there is none.
   */
  patternMessage: string;
  /**
   * Shown in the empty field. Empty where there is none.
   */
  placeholder: string;
  /**
   * Whether it is supplied once per trusted platform or once per access rule.
   */
  tier: WorkloadPlatformVariableTier;
};

/** @internal */
export const WorkloadPlatformVariableTier$inboundSchema: z.ZodMiniEnum<
  typeof WorkloadPlatformVariableTier
> = z.enum(WorkloadPlatformVariableTier);

/** @internal */
export const WorkloadPlatformVariable$inboundSchema: z.ZodMiniType<
  WorkloadPlatformVariable,
  unknown
> = z.pipe(
  z.object({
    help: z.string(),
    key: z.string(),
    label: z.string(),
    pattern: z.string(),
    pattern_message: z.string(),
    placeholder: z.string(),
    tier: WorkloadPlatformVariableTier$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "pattern_message": "patternMessage",
    });
  }),
);

export function workloadPlatformVariableFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformVariable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatformVariable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformVariable' from JSON`,
  );
}
